import type { ComponentStyleConfig } from "@chakra-ui/theme";
import { textStyles } from "theme/text-styles";

export const Tooltip: ComponentStyleConfig = {
  baseStyle: {
    "--tooltip-bg": "var(--chakra-colors-white)",
    "--popper-arrow-shadow-color": "var(--chakra-colors-brand-border-dark)",
    border: "1px",
    borderColor: "brand.border.dark",
    borderRadius: "tiny",
    bg: "white",
    dropShadow: "0px 0px 6px rgba(0, 0, 0, 0.30)",
    maxW: "260px",
    p: "smallest",
    ...textStyles.caption2,
  },
};
